import { motion } from "framer-motion";
import { LogoMark } from "@/components/Logo";

const APP_URL = "https://mobile-replica-build.emergent.host";
const HERO_IMG = "https://images.pexels.com/photos/257360/pexels-photo-257360.jpeg?auto=compress&cs=tinysrgb&w=1200";

export default function Hero({ onSignup }) {
    return (
        <section id="top" className="relative min-h-[92vh] flex flex-col overflow-hidden" data-testid="hero-section">
            <img
                src={HERO_IMG}
                alt="A peaceful tree-lined park path"
                className="absolute inset-0 w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/35 to-black/70" aria-hidden="true" />

            <div className="relative flex-1 flex flex-col px-6 pt-16 pb-12">
                <motion.div
                    initial={{ opacity: 0, scale: 0.85 }}
                    animate={{ opacity: 1, scale: 1 }}
                    transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
                    className="self-center mt-4"
                >
                    <LogoMark size={150} />
                </motion.div>

                <div className="mt-auto text-left">
                <motion.span
                    initial={{ opacity: 0, y: 14 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.6, delay: 0.35 }}
                    className="inline-block rounded-full bg-teal px-4 py-1.5 text-[11px] font-bold tracking-[0.14em] text-white uppercase"
                    data-testid="hero-badge"
                >
                    FDA-Verified · AI-Powered
                </motion.span>

                <motion.h1
                    initial={{ opacity: 0, y: 22 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.7, delay: 0.45 }}
                    className="mt-5 text-white font-extrabold tracking-tight leading-[1.05] text-[2.6rem]"
                    data-testid="hero-headline"
                >
                    Your reliable medication companion
                </motion.h1>

                <motion.p
                    initial={{ opacity: 0, y: 18 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.7, delay: 0.6 }}
                    className="mt-4 text-white/85 text-base leading-relaxed"
                    data-testid="hero-subheadline"
                >
                    Stay on schedule with kind, clear reminders. Understand what you take.
                    Share with the people who care.
                </motion.p>

                <motion.div
                    initial={{ opacity: 0, y: 18 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.7, delay: 0.75 }}
                    className="mt-8 w-full space-y-3.5"
                >
                    <button
                        onClick={onSignup}
                        className="w-full h-14 rounded-full bg-teal text-white font-bold text-lg shadow-[0_12px_30px_-8px_rgba(20,184,166,0.6)] transition-all duration-200 hover:bg-teal-dark active:scale-[0.98]"
                        data-testid="hero-get-started-button"
                    >
                        Get started free
                    </button>
                    <a
                        href={APP_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="w-full h-14 rounded-full border-2 border-teal text-teal font-bold text-lg flex items-center justify-center bg-black/20 backdrop-blur-sm transition-all duration-200 hover:bg-teal/10 active:scale-[0.98]"
                        data-testid="hero-login-button"
                    >
                        I already have an account
                    </a>
                    <p className="text-white/70 text-sm pt-1 text-center" data-testid="hero-trial-note">
                        7-day free trial · Cancel anytime
                    </p>
                </motion.div>
                </div>
            </div>
        </section>
    );
}
